import '../../../vendor/picker';
import '../../../vendor/picker.date';

// we expect that the date format in the input is yyyy-mm-dd
$(() => {
  function onStart() {
    const currentVal = this.get('value');

    if (!currentVal) {
      const today = new Date();
      if (!this.$node.data('datepicker-blank')) {
        this.set('select', [today.getFullYear(), today.getMonth(), today.getDate()]);
      }
    } else {
      // we subtract 1 from the month because JS months are zero indexed
      const dateParts = currentVal.split('-');
      this.set('select', [dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2]]);
    }
  }

  $('.pickadate').pickadate({
    format: 'mmm d, yyyy',
    onStart,
  });
});



// WEBPACK FOOTER //
// ./src/components/legacy/init/datepicker.js